
(function() {
  var result = { translations: { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84", "days": "{{ days }}\uC77C", "shortForm": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "days": "{{ days }}\uC77C", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} {{quarterNumber}}\uBD84\uAE30" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \uB0B4\uC120\uBC88\uD638: {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.1326"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1326",
    "ar-eg": "static-7.1326",
    "bg": "static-7.1326",
    "bn": "static-7.1326",
    "ca-es": "static-7.1326",
    "cs": "static-7.1326",
    "da": "static-7.1326",
    "de": "static-7.1326",
    "el": "static-7.1326",
    "en-gb": "static-7.1326",
    "en": "static-7.1326",
    "es-mx": "static-7.1326",
    "es": "static-7.1326",
    "et": "static-7.1326",
    "fi": "static-7.1326",
    "fr-ca": "static-7.1326",
    "fr": "static-7.1326",
    "he-il": "static-7.1326",
    "hi": "static-7.1326",
    "hr": "static-7.1326",
    "hu": "static-7.1326",
    "id": "static-7.1326",
    "it": "static-7.1326",
    "ja": "static-7.1326",
    "ko": "static-7.1326",
    "lt": "static-7.1326",
    "ms": "static-7.1326",
    "nl": "static-7.1326",
    "no": "static-7.1326",
    "pl": "static-7.1326",
    "pt-br": "static-7.1326",
    "pt-pt": "static-7.1326",
    "ro": "static-7.1326",
    "ru": "static-7.1326",
    "sk": "static-7.1326",
    "sl": "static-7.1326",
    "sv": "static-7.1326",
    "th": "static-7.1326",
    "tl": "static-7.1326",
    "tr": "static-7.1326",
    "uk": "static-7.1326",
    "vi": "static-7.1326",
    "x-pseudo": "static-7.1326",
    "zh-cn": "static-7.1326",
    "zh-hk": "static-7.1326",
    "zh-tw": "static-7.1326"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.1326'}); }
})();


